import { useTranslation } from "react-i18next";
import { Money } from "./Money";
import { refNumberFor } from "./refNumber";
import { localPick } from "../../lib/localName";

// اللوحة الموسّعة تحت الصف: تفاصيل القيد كاملة (بيان، بنود، توازن).
export const JournalExpanded = ({ entry, branchName }) => {
  const { t, i18n } = useTranslation();
  const ar = i18n.language === "ar";
  const balanced = entry.total_debit === entry.total_credit;
  const ref = refNumberFor(entry);

  return (
    <div className="grid gap-3 rounded-3xl border border-primary/30 bg-primary/5 p-5 text-xs"
         style={{ boxShadow: "0 14px 28px rgba(0,0,0,0.28), 0 6px 10px rgba(0,0,0,0.18), inset 0 1.5px 0 rgba(255,255,255,0.20), inset 0 -3px 8px rgba(0,0,0,0.14)" }}
         data-testid={`entry-expanded-${entry.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="font-bold text-primary">
          {t("acct.journal.detailTitle")}: <span className="font-mono">{entry.number}</span>
        </p>
        <span className="rounded-full bg-amber-500/15 px-3 py-1 font-mono text-[11px] font-bold text-amber-700" dir="ltr">
          {t("acct.journal.col.ref")}: {ref}
        </span>
        {branchName ? (
          <span className="rounded-full bg-primary/15 px-3 py-1 text-[11px] font-bold text-primary">
            {t("acct.journal.col.branch")}: {branchName}
          </span>
        ) : null}
      </div>
      <p className="text-muted-foreground">{t("acct.journal.col.desc")}: {entry.description || "—"}</p>

      <div className="grid gap-1.5">
        <div className="grid grid-cols-[1fr_auto_auto] gap-3 border-b border-border/40 pb-1 text-[10px] font-bold uppercase text-muted-foreground">
          <span>{t("acct.journal.col.account")}</span>
          <span className="w-28 text-end">{t("acct.journal.col.debit")}</span>
          <span className="w-28 text-end">{t("acct.journal.col.credit")}</span>
        </div>
        {(entry.lines || []).map((line, i) => (
          <div key={i} className="grid grid-cols-[1fr_auto_auto] items-center gap-3">
            <span className="min-w-0 truncate">
              <span className="font-mono font-bold text-primary" dir="ltr">{line.account_code}</span>
              {" — "}{localPick(line, "account_name")}
            </span>
            <Money value={line.debit} currency={entry.currency} className="w-28 text-end" />
            <Money value={line.credit} currency={entry.currency} className="w-28 text-end" dim />
          </div>
        ))}
      </div>

      <div className="flex items-center justify-end gap-3 border-t border-border/40 pt-2 font-bold">
        <span className={`rounded-full px-3 py-1 text-[10px] ${
          balanced ? "bg-emerald-500/15 text-emerald-600" : "bg-rose-500/15 text-rose-600"}`}>
          {balanced ? `✓ ${t("acct.journal.balanced")}` : `✗ ${t("acct.journal.unbalanced")}`}
        </span>
        <Money value={entry.total_debit} currency={entry.currency} />
        <Money value={entry.total_credit} currency={entry.currency} dim />
      </div>
    </div>
  );
};
